<template>
  <Common :event="event" :add-time="0" @end="end" @realEnd="realEnd">
    <CommonQue class="que-wrap" v-if="showQue" :params="params" />
  </Common>
</template>
<script>
// 一呼百应
import { computed } from '@vue/composition-api'
import Common from './Common.vue'
import CommonQue from './CommonQue.vue'
export default {
  components: {
    Common,
    CommonQue
  },
  props: {
    event: Object
  },
  setup(props, { emit }) {
    const params = computed(() => props.event.params)
    // 显示题目，有题干就显示题目
    const showQue = computed(() => {
      const { topicContent } = params.value
      return !!topicContent
    })
    function end() {
      // 倒计时结束
      emit('end', event)
    }
    function realEnd() {
      // 倒计时结束
      emit('realEnd', event)
    }
    return {
      showQue,
      params,
      end,
      realEnd
    }
  }
}
</script>
<style lang="less" scoped>
.que-wrap {
  width: 520px;
}
</style>
